var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unemployment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.67 4.79803L18.5 9.62803V20.798H6.5V4.79803H13.67ZM14.5 2.79803H6.5C5.4 2.79803 4.5 3.69803 4.5 4.79803V20.798C4.5 21.898 5.4 22.798 6.5 22.798H18.5C19.6 22.798 20.5 21.898 20.5 20.798V8.79803L14.5 2.79803ZM15.5 11.798H11.5V12.798H14.5C15.05 12.798 15.5 13.248 15.5 13.798V16.798C15.5 17.348 15.05 17.798 14.5 17.798H13.5V18.798H11.5V17.798H9.5V15.798H13.5V14.798H10.5C9.95 14.798 9.5 14.348 9.5 13.798V10.798C9.5 10.248 9.95 9.79803 10.5 9.79803H11.5V8.79803H13.5V9.79803H15.5V11.798Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5 11.798H11.5V12.798H14.5C15.05 12.798 15.5 13.248 15.5 13.798V16.798C15.5 17.348 15.05 17.798 14.5 17.798H13.5V18.798H11.5V17.798H9.5V15.798H13.5V14.798H10.5C9.95 14.798 9.5 14.348 9.5 13.798V10.798C9.5 10.248 9.95 9.79803 10.5 9.79803H11.5V8.79803H13.5V9.79803H15.5V11.798Z",
    fill: "#14AA3C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario8);
export default __webpack_public_path__ + "static/media/Scenario8.f5d1844d26894bd668c4e7463dad5920.svg";
export { ForwardRef as ReactComponent };